import { Box } from '@hivebrite/design-system/Box';
import { CardWithTitle } from '@hivebrite/design-system/Card';
import { Divider } from '@hivebrite/design-system/Divider';

import type { AddonItem } from 'hb-react/shared/apps/Events/pages/Booking/hooks/useBooking';
import AddonCheckbox from 'hb-react/shared/apps/Events/pages/Booking/pages/Registration/components/Form/components/AddonCheckbox';

export const StandaloneAddons = ({ addons = [] }: { addons: AddonItem[] }) =>
  addons.length > 0 ? (
    <CardWithTitle title={__('Additional Items')}>
      {addons.map((addon, index) => (
        <Box key={addon.id} flexDirection="column">
          <AddonCheckbox name={`addons[${index}]`} addon={addon} />
          {index + 1 < addons.length && <Divider my={3} />}
        </Box>
      ))}
    </CardWithTitle>
  ) : null;
